module.exports = __webpack_public_path__ + "img/friendly-persona.4b58c627.svg";